import { NgModule, forwardRef, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, registerLocaleData } from "@angular/common";
import { ComboComponent } from "./filters/combo/combo.component";
import { DateFilterComponent } from "./filters/date-filter/date-filter/date-filter.component";
import { TextFilterComponent } from "./filters/text-filter/text-filter.component";
import { FiltersComponentComponent } from "./filters/filters-component/filters-component.component";
import { FocusDivDirective } from "./filters/directives/focus-div.directive";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatNativeDateModule } from "@angular/material/core";
import { TableComponent } from './smart/table/table.component';
import { AthleteNameComponent } from './view-components/athlete-name/athlete-name.component';
import { TeamNameComponent } from './view-components/team-name/team-name.component';
import { StageNameComponent } from './view-components/stage-name/stage-name.component';
import { BaseComponentComponent } from './common/base-component/base-component.component';
import { LoaderComponent } from './common/loader/loader.component';
import { AthletePhotoComponent } from './view-components/athlete-photo/athlete-photo.component';
import { AthleteRankComponent } from './view-components/athlete-rank/athlete-rank.component';
import { ParseRankPipe } from './pipes/parse-rank.pipe';
import { GetRankClassPipe } from './pipes/get-rank-class.pipe';
import { CountryNameFlagComponent } from './view-components/country-name-flag/country-name-flag.component';
import { DateComponent } from './view-components/date/date.component';
import { TableTitleComponent } from './view-components/table-title/table-title.component';
import { AthletePositionComponent } from './view-components/athlete-position/athlete-position.component';
import { CountryFlagComponent } from './view-components/country-flag/country-flag.component';
import { CountryNamePipe } from './pipes/country-name.pipe';
import { TableHeadersComponent } from './smart/table-headers/table-headers.component';
import { RangeDateFilterComponent } from './filters/date-filter/range-date-filter/range-date-filter.component';
import { SatDatepickerModule, SatNativeDateModule } from 'saturn-datepicker';
import { DateSimpleRangeComponent } from './filters/date-simple-range/date-simple-range.component';
import { HttpClientModule } from '@angular/common/http';
import { ComboTextSearchFilterComponent } from './filters/combo-text-search-filter/combo-text-search-filter.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { RouterModule } from '@angular/router/';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { HeaderCalendarComponent } from './filters/header-calendar/header-calendar.component';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@ngneat/transloco';
import { CommonTranslateModule } from '../../../common-page-components/transloco-module/common-translate-module.module';

// Register the french locale.

import localeFr from '@angular/common/locales/fr';
import { LoadDrupalLangService } from "src/app/common-page-components/services/load-drupal-lang.service";
import { FiltersRouterDirective, RouterFilterReference } from './common/filters-router/filters-router.component';


registerLocaleData(localeFr);
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CommonTranslateModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    RouterModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    SatDatepickerModule,
    SatNativeDateModule,
    HttpClientModule,
    MatAutocompleteModule,
    MatAutocompleteModule,
    LazyLoadImageModule,
    MatIconModule,
    MatButtonModule
  ],
  declarations: [
    RouterFilterReference,
    ComboComponent,
    DateFilterComponent,
    TextFilterComponent,
    FiltersComponentComponent,
    FocusDivDirective,
    TableComponent,
    AthleteNameComponent,
    TeamNameComponent,
    StageNameComponent,
    BaseComponentComponent,
    LoaderComponent,
    AthletePhotoComponent,
    AthleteRankComponent,
    ParseRankPipe,
    GetRankClassPipe,
    CountryNameFlagComponent,
    DateComponent,
    TableTitleComponent,
    AthletePositionComponent,
    CountryFlagComponent,
    CountryNamePipe,
    TableHeadersComponent,
    RangeDateFilterComponent,
    DateSimpleRangeComponent,
    ComboTextSearchFilterComponent,
    HeaderCalendarComponent,
    FiltersRouterDirective
  ],
  exports: [
    ComboComponent,
    DateFilterComponent,
    TextFilterComponent,
    FiltersComponentComponent,
    FocusDivDirective,
    TableComponent,
    AthleteNameComponent,
    TeamNameComponent,
    StageNameComponent,
    BaseComponentComponent,
    LoaderComponent,
    AthletePhotoComponent,
    AthleteRankComponent,
    ParseRankPipe,
    GetRankClassPipe,
    CountryNameFlagComponent,
    DateComponent,
    TableTitleComponent,
    AthletePositionComponent,
    CountryFlagComponent,
    CountryNamePipe,
    TableHeadersComponent,
    RangeDateFilterComponent,
    LazyLoadImageModule,
    HeaderCalendarComponent,
    FiltersRouterDirective
  ],
  entryComponents: [HeaderCalendarComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  providers: [GetRankClassPipe, ParseRankPipe, CountryNamePipe,
    { provide: LOCALE_ID, useFactory: () => LoadDrupalLangService.getRawLang() },

  ]
})
export class ComponentsModule {
  constructor(
    public matIconRegistry: MatIconRegistry) {
  }
}
